import api from './../api';

export default {
    namespaced: true,

    state: {
        item: {}
    },
    getters: {

    },
    actions: {
        list(store, params) {
            return new Promise((resolve, reject) => {
                api.post('order/list', params).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        get(store, id) {
            return new Promise((resolve, reject) => {
                api.get('order/' + id).then(response => {
                    store.commit('setItem', response.data);
                    resolve();
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        remove(store, id) {
            return new Promise((resolve, reject) => {
                api.delete('order/' + id).then(response => {
                    store.commit('resetItem');
                    resolve();
                }).catch(error => {
                    // todo: catch error
                    reject(error.response);
                });
            });
        },
        create(store, params) {
            return new Promise((resolve, reject) => {
                api.post('order', params).then(response => {
                    store.commit('setItem', response.data);
                    store.dispatch('alert/success', 'Order was created', {root: true});
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                });
            });
        },
        update(store, params) {
            return new Promise((resolve, reject) => {
                api.put('order/' + params.id, params).then(response => {
                    store.commit('setItem', response.data);
                    store.dispatch('alert/success', 'Order was updated', {root: true});
                    resolve(response.data);
                }).catch(error => {
                    store.dispatch('alert/warning', error.data.status);
                    reject(error.response);
                });
            });
        },
    },
    mutations: {
        setItem(state, data) {
            state.item = data;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/orders.js